import { createTheme } from '@rneui/themed';

const colors = {
  antiFlashWhite: '#f1f1f1',
  brightGray: '#E7F2EC',
  chineseSilver: '#C7C7C7',
  coralRed: '#FF4438',
  cultured: '#f3f7fa',
  manatee: '#9299AB',
  mediumAquamarine: '#58D4A4',
  midnightGreen: '#003E52',
  midnightGreenOpacity: 'rgba(0, 62,82, 0.6)',
  nickel: '#737373',
  pear: '#CCDB2A',
  persianGreen: '#00B189'
};

const theme = {
  lightColors: {
    background: colors.cultured,
    grey0: colors.antiFlashWhite,
    grey1: colors.chineseSilver,
    grey2: colors.nickel,
    grey3: colors.midnightGreenOpacity,
    greyOutline: colors.brightGray,
    primary: colors.midnightGreen,
    searchBg: colors.mediumAquamarine,
    secondary: colors.coralRed,
    success: colors.persianGreen,
    text: colors.manatee,
    warning: colors.pear
  },
  darkColors: {
    background: colors.cultured,
    grey0: colors.antiFlashWhite,
    grey1: colors.chineseSilver,
    grey2: colors.nickel,
    grey3: colors.midnightGreenOpacity,
    greyOutline: colors.brightGray,
    primary: colors.midnightGreen,
    searchBg: colors.mediumAquamarine,
    secondary: colors.coralRed,
    success: colors.persianGreen,
    warning: colors.pear
  },
  components: {

  }
};

export default createTheme(theme);
